import PropTypes from "prop-types";
import AgentActivityHeaders from "./AgentActivityHeaders";
import AgentCallsHeaders from "./AgentCallsHeaders";
import AgentTextsHeaders from "./AgentTextsHeaders";
import LeadSourcesHeaders from "./LeadSourcesHeaders";
import TasksHeaders from "./TasksHeaders";

const HEADER_COMPONENTS = {
  teamDashboard: () => null,
  agentActivity: AgentActivityHeaders,
  leadSource: LeadSourcesHeaders,
  tasks: TasksHeaders,
  appointments: () => null,
  agentCalls: AgentCallsHeaders,
  agentTexts: AgentTextsHeaders,
  leaderboards: () => null,
};

const ReportHeaderSortContainer = (props) => {
  const { activeReport } = props;
  const ReportName = HEADER_COMPONENTS[activeReport || "agentActivity"];
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ReportName {...props} />;
};

ReportHeaderSortContainer.propTypes = {
  activeReport: PropTypes.string.isRequired,
};

export default ReportHeaderSortContainer;
